import styled from "styled-components";
export const SliderArrow = styled.button(
  (props) => `
      width: 4rem;
      height: 4rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      outline: 0;
      &.right {
        display: flex;
        right: 0;
        margin-top: 86px;
        transform: translateY(-50%);
      }
      &.left {
        display: flex;
        left: -1rem;
        margin-top: 86px;
        transform: translateY(-50%);
      }
    `
);

export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => props.flexDirection};
`;
